<template>
  <div>
    <v-data-table
      style="overflow: hidden"
      :items="items"
      :headers="headers"
      :hide-default-footer="true"
      :hide-default-header="$vuetify.breakpoint.name != 'xs'"
      class="elevation-5 rounded-lg"
      :items-per-page="por_pagina"
    >
      <template
        v-slot:header="{ props, on }"
        #header
        v-if="$vuetify.breakpoint.name != 'xs'"
      >
        <thead>
          <tr>
            <th
              v-for="h in props.headers"
              :key="h.value"
              :style="{'padding-block': '2em', width: h.width, cursor: h.sortable !== false ? 'pointer' : 'default' }"
              @click="h.sortable !== false && on.sort(h.value)"
            >
                <div
                :class="getHeaderAlignClass(h)"
                :style="{ display: 'flex', alignItems: 'center', justifyContent: getHeaderJustify(h) }"
              >
                <p style="font-size: 1.15em; color: black; font-weight: bold; margin:0;">
                  {{ h.text }}
                </p>
                <v-icon v-if="h.sortable !== false" small class="ml-1">
                  {{
                    props.options.sortBy.includes(h.value)
                      ? props.options.sortDesc[0] ? 'mdi-arrow-down' : 'mdi-arrow-up'
                      : 'mdi-swap-vertical'
                  }}
                </v-icon>
              </div>

            </th>
          </tr>
        </thead>
      </template>


      <template v-for="v in slotsColumn" #[`item.${v}`]="{ item, index }">
        <slot :name="v" :item="item" :index="index" />
      </template>

      <template v-slot:body.append v-if="mostrarResumenPuntaje">
        <!-- MOBILE -->
        <tr v-if="$vuetify.breakpoint.xsOnly">
          <td :colspan="headers.length" class="p-0">
            <table class="w-100 resumen-mobile-table">
              <tr>
                <td class="font-weight-bold resumen-mobile-table-label">
                  {{ textoResumenNormalized }}
                </td>
                <td class="resumen-mobile-table-value">
                  {{ calcularPromedio(columnaResumen) }}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- DESKTOP -->
        <tr v-else>
          <td
            v-for="(header, index) in headers"
            :key="header.value"
          >
            <div
              v-if="index === 0"
              class="text-start"
            >
              {{ textoResumenNormalized }}
            </div>
            <div
              v-if="header.value === columnaResumen"
              :class="getHeaderAlignClass(header)"
            >
              {{ calcularPromedio(columnaResumen) }}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div class="mt-4" v-if="!sinPaginacion">
      <app-pagination
        v-model="numPage"
        :total-pages="total"
        :per-page="por_pagina"
        @change="changePagina"
        @perPageChange="changePerPage"
      ></app-pagination>
    </div>
  </div>
</template>

<script>
// import AppPagination from "@/components/AppPagination.vue";
import AppPagination from "../../../components/ComponentPaginationProcess.vue";

export default {
  components: { AppPagination },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    headerSlot: {
      type: String,
      default: ""
    },
    slotsColumn: {
      type: Array,
      default: () => []
    },
    por_pagina: {
      type: Number,
      default: 5
    },
    page: {
      type: Number,
      default: 1
    },
    totalRegistros: {
      type: Number,
      default: 0
    },
    sinPaginacion: {
      type: Boolean,
      default: false
    },
    mostrarResumenPuntaje: {
      type: Boolean,
      default: false
    },
    columnaResumen: {
      type: String,
      default: 'puntaje'
    },
    textoResumen: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      numPage: 0
    };
  },
  methods: {
    // changePaginarion(page) {
    //   this.$emit('change', page)
    // }
    changePagina(nuevo, old) {
      this.$emit("paginationChange", nuevo);
    },
    changePerPage(newPerPage) {
      try {
           this.$emit("cambioPorPagina", newPerPage);
      } catch (error) {
        console.error("Error emitting cambioPorPagina:", error);
      }
     
    },
    getHeaderAlignClass(header) {
      const headerAlign = header['header-align'] || 'center'
      if (headerAlign === 'start') return 'text-left'
      if (headerAlign === 'end') return 'text-right'
      return 'text-center'
    },
    getHeaderJustify(header) {
      const headerAlign = header['header-align'] || 'center'
      if (headerAlign === 'start') return 'flex-start'
      if (headerAlign === 'end') return 'flex-end'
      return 'center'
    },
    calcularPromedio(columna) {
      if (!this.items.length) return 0

      const total = this.items.reduce((sum, item) => {
        return sum + Number(item[columna] || 0)
      }, 0)

      return (total / this.items.length).toFixed(2)
    },
  },
  computed: {
    total() {
      return Math.ceil(this.totalRegistros / this.por_pagina);
    }
    ,textoResumenNormalized() {
      if (!this.textoResumen) return '';
      // Reemplaza NBSP por espacio normal
      let s = String(this.textoResumen).replace(/\u00A0/g, ' ');
      // Inserta un separador de ancho cero cada 20 caracteres en palabras largas sin espacios
      s = s.replace(/([^\s]{20,})/g, (m) => m.replace(/(.{20})/g, '$1\u200B'));
      return s;
    }
  },
  watch: {
    items: function (nuevo, anterior) {
      if (nuevo.length === 0 && this.numPage !== 1) {
        this.numPage = 1;
      }
    },
    page: {
      handler(newPage) {
        this.numPage = newPage;
      },
      immediate: false
    }
  },
  created() {
    this.numPage = this.page;
  }
};
</script>
<style>
tbody tr:nth-of-type(odd) {
  background-color: #eeeeee;
}

.v-data-table > .v-data-table__wrapper > table > thead tr:nth-of-type(odd) th {
  background-color: white;
}

.v-data-table > .v-data-table__wrapper > table > tbody tr:nth-of-type(odd) td {
  background-color: #eeeeee;
}

.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  tr:not(:nth-of-type(odd))
  td {
  background-color: white;
}

/* thead tr > td {
  position: sticky;
  left: 0;
}

tbody tr > td {
  position: sticky;
  left: 0;
} */

thead th:last-child,
tbody td:last-child {
  right: 0;
  z-index: 1;
  position: sticky;
}

/* Mobile resumen: permitir que el texto se quiebre y el valor quede a la derecha */
.resumen-mobile-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.resumen-mobile-texto {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  white-space: normal !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
}

.resumen-mobile-valor {
  flex: 0 0 auto;
  flex-shrink: 0;
  margin-left: 12px;
  white-space: nowrap;
}

/* estilos para la tabla anidada del resumen móvil */
.resumen-mobile-table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}
.resumen-mobile-table-label {
  width: 70%;
  padding: 0 !important;
  white-space: normal !important;
  word-break: break-word !important;
}
.resumen-mobile-table-value {
  width: 70px;
  padding: 0 !important;
  padding-left: 8px !important;
  white-space: nowrap;
  text-align: right;
}
</style>
